import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup, Label, Input,
} from 'reactstrap';
import {
  regexPattern, staticConstants, GRAPH_CONST_VALUES,
} from '../../../utils';

function RenderInputFiled(props) {
  const {
    errors, register, formData, type,
  } = props;

  const renderInputFiled = (label, inputName, fieldType) => (
    <FormGroup className={`input-field
      ${fieldType === GRAPH_CONST_VALUES.FB_RATE && 'demographic-input'}
      ${fieldType === GRAPH_CONST_VALUES.ETHNICITY_LABEL.ASIAN && 'field-group'}
      ${errors[inputName] && `${staticConstants.ERROR_CLASS.FORM_ERROR}`}`}
    >
      <Label
        for={label}
      >
        {label}
      </Label>
      <Input
        type="text"
        name={inputName}
        value={formData[inputName]}
        placeholder="%"
        innerRef={register({
          pattern: {
            value: regexPattern.NUMBER_ZERO_TO_HUNDRED_DECIMAL,
          },
        })}
      />
    </FormGroup>
  );

  const renderAuthenticFileds = (key, label, inputName) => key === GRAPH_CONST_VALUES.AUTHENTIC
    && renderInputFiled(label, inputName);

  const renderAudienceFileds = (key, label, inputName) => key === GRAPH_CONST_VALUES.AUDIENCE
    && renderInputFiled(label, inputName);

  const renderEthnicityFileds = (key, label, inputName, fieldType) => key === GRAPH_CONST_VALUES.ETHNICITY
    && renderInputFiled(label, inputName, fieldType);

  const renderEngagementFileds = (key, label, inputName, fieldType) => key === GRAPH_CONST_VALUES.ENGAGEMENT
    && renderInputFiled(label, inputName, fieldType);

  return (
    <>
      {renderAuthenticFileds(type, GRAPH_CONST_VALUES.AUTHENTIC_LABEL, GRAPH_CONST_VALUES.AUTHENTIC_FOLLOWERS)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_13_17, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_13_17)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_18_20, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_18_20)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_21_24, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_21_24)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_25_29, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_25_29)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_30_34, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_30_34)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_35_44, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_35_44)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_45_64, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_45_64)}
      {renderAudienceFileds(type, GRAPH_CONST_VALUES.AGE_LABEL.AGE_65_PLUS, GRAPH_CONST_VALUES.AUDIENCE_AGE.AGE_65_PLUS)}
      {renderEthnicityFileds(type, GRAPH_CONST_VALUES.ETHNICITY_LABEL.AMERICAN, GRAPH_CONST_VALUES.ETHNICITY_VALUE.AMERICAN, GRAPH_CONST_VALUES.ETHNICITY_LABEL.ASIAN)}
      {renderEthnicityFileds(type, GRAPH_CONST_VALUES.ETHNICITY_LABEL.ASIAN, GRAPH_CONST_VALUES.ETHNICITY_VALUE.ASIAN, GRAPH_CONST_VALUES.ETHNICITY_LABEL.ASIAN)}
      {renderEthnicityFileds(type, GRAPH_CONST_VALUES.ETHNICITY_LABEL.WHITE, GRAPH_CONST_VALUES.ETHNICITY_VALUE.WHITE, GRAPH_CONST_VALUES.ETHNICITY_LABEL.ASIAN)}
      {renderEthnicityFileds(type, GRAPH_CONST_VALUES.ETHNICITY_LABEL.HISPANIC, GRAPH_CONST_VALUES.ETHNICITY_VALUE.HISPANIC, GRAPH_CONST_VALUES.ETHNICITY_LABEL.ASIAN)}
      {renderEngagementFileds(type, staticConstants.SOCIAL_SHARE_TYPE.FACEBOOK, GRAPH_CONST_VALUES.FB_RATE, GRAPH_CONST_VALUES.FB_RATE)}
      {renderEngagementFileds(type, staticConstants.SOCIAL_SHARE_TYPE.INSTAGRAM, GRAPH_CONST_VALUES.INSTA_RATE, GRAPH_CONST_VALUES.FB_RATE)}
      {renderEngagementFileds(type, staticConstants.SOCIAL_SHARE_TYPE.TWITTER, GRAPH_CONST_VALUES.TWITTER_RATE, GRAPH_CONST_VALUES.FB_RATE)}
    </>
  );
}

RenderInputFiled.propTypes = {
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default RenderInputFiled;
